import type {
  MantineThemeOverride,
} from "@mantine/core";
import { variantColorResolver } from "./theme/variantColorResolver.js";
import { colors } from "./theme/colors.js";
import { typography } from "./theme/typography.js";
import { components } from "./theme/components.js";

export const themeOverrides: MantineThemeOverride = {
  colors,
  components,
  ...typography,
  variantColorResolver,
  primaryColor: "orange",
  defaultRadius: "md",
  breakpoints: {
    xs: "36em",
    sm: "48em",
    md: "64em",
    lg: "74em",
    xl: "90em",
  },
};
